import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import { formatFechaWithHour } from "../../../utils/dateFunctions";
import EstadoBadge from "./EstadoBadge";
import AddSubscriptionToOrgModal from "./AddSubscriptionToOrgModal";
import AddRoleToOrgModal from "./AddRoleToOrgModal";
import AddIcon from "@mui/icons-material/Add";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const OrgTable = () => {
  const { myOrgs } = useSingleUserControl();
  const [selectedOrg, setSelectedOrg] = useState<{
    id: string;
    name: string;
  } | null>(null);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showRoleModal, setShowRoleModal] = useState(false);

  const estadoMap: Record<string, "success" | "warning" | "wrong" | "unknown"> =
  {
    Activo: "success",
    Inactivo: "warning",
    Eliminado: "wrong",
  };

  const handleAddSubscription = (orgId: string, orgName: string) => {
    setSelectedOrg({ id: orgId, name: orgName });
    setShowSubscriptionModal(true);
  };

  const handleAddRole = (orgId: string, orgName: string) => {
    setSelectedOrg({ id: orgId, name: orgName });
    setShowRoleModal(true);
  };

  return (
    <>
      <TableContainer
        sx={{
          fontFamily: "Montserrat, sans-serif",
          boxShadow: "none",
          color: "#005559",
          px: 2,
        }}
      >
        <Table
          sx={{
            borderCollapse: "collapse",
            "& .MuiTableCell-root": {
              fontFamily: "Montserrat, sans-serif",
              padding: "6px 12px",
              borderBottom: "none",
              color: "#005559",
            },
          }}
        >
          <TableHead>
            <TableRow
              sx={{
                borderBottom: "1px solid #336B8780",
              }}
            >
              <TableCell sx={{ fontWeight: 700 }}>ID</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Organización</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Fecha de asignación</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Estado</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {myOrgs.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={5}
                  align="center"
                  sx={{
                    fontStyle: "italic",
                    color: "#7A7A7A",
                    py: 2,
                  }}
                >
                  No se encuentra asociado a ninguna organización
                </TableCell>
              </TableRow>
            ) : (
              myOrgs.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": { backgroundColor: "#f5f5f5" },
                    borderBottom:
                      index === myOrgs.length - 1 ? "none" : "1px solid #e0e0e0",
                  }}
                >
                  <TableCell>{row.id_organizacion}</TableCell>
                  <TableCell>{row.organizacion}</TableCell>
                  <TableCell>{formatFechaWithHour(row.created_at)}</TableCell>
                  <TableCell>
                    <EstadoBadge estado={estadoMap[row.estado_org]}>
                      {row.estado_org}
                    </EstadoBadge>
                  </TableCell>
                  <TableCell>
                    <Tooltip title="Agregar Suscripción">
                      <IconButton
                        size="small"
                        onClick={() =>
                          handleAddSubscription(row.id_organizacion, row.organizacion)
                        }
                        sx={{
                          color: "#336B87",
                          "&:hover": { backgroundColor: "#336B8720" },
                        }}
                      >
                        <AddIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Agregar Rol">
                      <IconButton
                        size="small"
                        onClick={() =>
                          handleAddRole(row.id_organizacion, row.organizacion)
                        }
                        sx={{
                          color: "#336B87",
                          "&:hover": { backgroundColor: "#336B8720" },
                        }}
                      >
                        <PersonAddIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Modals */}
      {selectedOrg && (
        <>
          <AddSubscriptionToOrgModal
            isOpen={showSubscriptionModal}
            setIsOpen={setShowSubscriptionModal}
            organizationId={selectedOrg.id}
            organizationName={selectedOrg.name}
          />
          <AddRoleToOrgModal
            isOpen={showRoleModal}
            setIsOpen={setShowRoleModal}
            organizationId={selectedOrg.id}
            organizationName={selectedOrg.name}
          />
        </>
      )}
    </>
  );
};

export default OrgTable;
